module.exports = __webpack_public_path__ + "static/img/whitepeachginger_th.f44dbcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/whitepeachginger_th.png
// module id = 6z8k
// module chunks = 0